import adminRequestService from "../../services/adminRequest";
const getDefaultState = () => {
    return {
        EntityRequest: {
            code: null,
            name: null,
            isTimeOnly: null,
        },
        AgencyRequest: {
            EntityId: null,
            Name: null,
            MDMGuid: null,
            Id: 0,
        },
        AccountingOfficeRequest: {
            AgencyId: null,
            Id: 0,
            Code: null,
            Name: null,
            PrismaNGLocationId: null,
            PrismaNGLocationName: null,
            AXD365Location: null,
            SMICube: null,
        },
        MediaOfficeRequest: {
            AccountingOfficeId: null,
            Id: 0,
            Code: null,
            Name: null,
            SMICube: null,
            IsExcludeFromReporting: false,
        }
    };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
    EntityRequest: (state) => {
        return state.EntityRequest;
    },
    AgencyRequest: (state) => {
        return state.AgencyRequest;
    },
    AccountingOfficeRequest: (state) => {
        return state.AccountingOfficeRequest;
    },
    MediaOfficeRequest: (state) => {
        return state.MediaOfficeRequest;
    }
};

// actions
const actions = {
    AddEntity(st, data) {
        return adminRequestService.AddEntity(data, st.rootState.auth.idToken);
    },
    UpdateEntity(st, { id, data }) {
        return adminRequestService.UpdateEntity(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetEntities(st, data) {
        return adminRequestService.GetEntities(
            data,
            st.rootState.auth.idToken
        );
    },
    AddAgency(st, data) {
        return adminRequestService.AddAgency(data, st.rootState.auth.idToken);
    },
    UpdateAgency(st, { id, data }) {
        return adminRequestService.UpdateAgency(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetAllAgencies(st, data) {
        return adminRequestService.GetAllAgencies(data, st.rootState.auth.idToken);
    },
    AddAccountingOffice(st, data) {
        return adminRequestService.AddAccountingOffice(data, st.rootState.auth.idToken);
    },
    UpdateAccountingOffice(st, { id, data }) {
        return adminRequestService.UpdateAccountingOffice(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetAllAccountingOffices(st, data) {
        return adminRequestService.GetAllAccountingOffices(data, st.rootState.auth.idToken);
    },
    AddMediaOffice(st, data) {
        return adminRequestService.AddMediaOffice(data, st.rootState.auth.idToken);
    },
    UpdateMediaOffice(st, { id, data }) {
        return adminRequestService.UpdateMediaOffice(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetAllMediaOffices(st, data) {
        return adminRequestService.GetAllMediaOffices(data, st.rootState.auth.idToken);
    },
};
// mutations
const mutations = {
    reset(st) {
        const s = getDefaultState();
        Object.keys(st).forEach((d) => {
            st[d] = s[d];
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
